import { STUDENTS } from './students';

// Helper function to generate class data
const generateClass = (id, grade, section, subject, teacher, teacherId) => {
  const gradeLabel = grade === 'KG1' || grade === 'KG2' || grade === 'KG3' ? grade : `G${grade}`;
  const className = `${subject} ${gradeLabel}-${section}`;
  const schedules = ['Mon/Wed/Fri 8:00-9:30', 'Mon/Wed/Fri 9:00-10:30', 'Tue/Thu 10:00-11:30', 'Tue/Thu 13:00-14:30'];
  const rooms = ['Room 101', 'Room 102', 'Room 105', 'Room 201', 'Lab 203', 'Lab 301'];

  return {
    id,
    name: className,
    grade: grade === 'KG1' ? 0 : grade === 'KG2' ? -1 : grade === 'KG3' ? -2 : parseInt(grade),
    gradeLabel,
    section,
    subject,
    teacher,
    teacherId,
    schedule: schedules[id % schedules.length],
    room: rooms[id % rooms.length],
    students: [], // Will be populated based on student data
    curriculum: {
      completed: Math.floor(Math.random() * 18) + 5,
      total: 22,
      nextTopic: getNextTopic(subject)
    },
    attendanceRate: Math.floor(Math.random() * 10) + 88
  };
};

const getNextTopic = (subject) => {
  const topics = {
    'Mathematics': ['Numbers', 'Algebra', 'Geometry', 'Calculus', 'Statistics'],
    'Science': ['Biology', 'Chemistry', 'Physics', 'Earth Science'],
    'English': ['Reading', 'Writing', 'Grammar', 'Literature'],
    'Arabic': ['Reading', 'Writing', 'Grammar', 'Poetry'],
    'Social Studies': ['History', 'Geography', 'Civics'],
    'Art': ['Drawing', 'Painting', 'Sculpture'],
    'Music': ['Theory', 'Practice', 'Performance'],
    'PE': ['Sports', 'Fitness', 'Games'],
    'History': ['Ancient History', 'Modern History', 'World Wars', 'Revolutions'],
    'Geography': ['Physical Geography', 'Human Geography', 'Maps', 'Climate'],
    'Computer Science': ['Programming', 'Algorithms', 'Data Structures', 'Web Development'],
    'Physics': ['Mechanics', 'Thermodynamics', 'Optics', 'Electricity'],
    'Chemistry': ['Organic Chemistry', 'Inorganic Chemistry', 'Acids & Bases', 'Reactions'],
    'Biology': ['Cell Biology', 'Genetics', 'Evolution', 'Ecology'],
    'French': ['Grammar', 'Vocabulary', 'Literature', 'Conversation']
  };
  const topicList = topics[subject] || ['General Topic'];
  return topicList[Math.floor(Math.random() * topicList.length)];
};

// Create base classes first
const baseClasses = [
  // ========== KINDERGARTEN CLASSES ==========
  // KG1 - 3 sections (A, B, C)
  generateClass(1, 'KG1', 'A', 'Early Learning', 'Ms. Sara Ibrahim', 6),
  generateClass(2, 'KG1', 'B', 'Early Learning', 'Ms. Nour Hamza', 7),
  generateClass(3, 'KG1', 'C', 'Early Learning', 'Ms. Lina Khoury', 8),

  // KG2 - 3 sections (A, B, C)
  generateClass(4, 'KG2', 'A', 'Pre-K', 'Ms. Maya Sleiman', 9),
  generateClass(5, 'KG2', 'B', 'Pre-K', 'Ms. Dina Abou', 10),
  generateClass(6, 'KG2', 'C', 'Pre-K', 'Ms. Rima Younes', 11),

  // KG3 - 3 sections (A, B, C)
  generateClass(7, 'KG3', 'A', 'Kindergarten', 'Ms. Hala Farhat', 12),
  generateClass(8, 'KG3', 'B', 'Kindergarten', 'Ms. Jana Nasr', 13),
  generateClass(9, 'KG3', 'C', 'Kindergarten', 'Ms. Layla Slim', 14),

  // ========== GRADE 1 CLASSES ==========
  generateClass(10, '1', 'A', 'Mathematics', 'Ms. Reem Haddad', 15),
  generateClass(11, '1', 'B', 'Mathematics', 'Mr. Ali Mansour', 16),
  generateClass(12, '1', 'C', 'Mathematics', 'Ms. Nada Karam', 17),

  // ========== GRADE 2 CLASSES ==========
  generateClass(13, '2', 'A', 'Science', 'Mr. Omar Jaber', 18),
  generateClass(14, '2', 'B', 'Science', 'Ms. Zeina Habib', 19),
  generateClass(15, '2', 'C', 'Science', 'Ms. Mira Saleh', 20),

  // ========== GRADE 3 CLASSES ==========
  generateClass(16, '3', 'A', 'English', 'Ms. Carla Nakhle', 21),
  generateClass(17, '3', 'B', 'English', 'Mr. Tony Azar', 22),
  generateClass(18, '3', 'C', 'English', 'Ms. Nadine Gebran', 23),

  // ========== GRADE 4 CLASSES ==========
  generateClass(19, '4', 'A', 'Mathematics', 'Mr. Fadi Moussa', 24),
  generateClass(20, '4', 'B', 'Mathematics', 'Ms. Rita Bitar', 25),
  generateClass(21, '4', 'C', 'Mathematics', 'Mr. George Saab', 26),

  // ========== GRADE 5 CLASSES ==========
  generateClass(22, '5', 'A', 'Science', 'Dr. Sami Haddad', 27),
  generateClass(23, '5', 'B', 'Science', 'Ms. Lara Frem', 28),
  generateClass(24, '5', 'C', 'Science', 'Mr. Karim Dagher', 29),

  // ========== GRADE 6 CLASSES ==========
  generateClass(25, '6', 'A', 'Social Studies', 'Mr. Elie Hayek', 30),
  generateClass(26, '6', 'B', 'Social Studies', 'Ms. Tala Sfeir', 31),
  generateClass(27, '6', 'C', 'Social Studies', 'Mr. Maroun Khoury', 32),

  // ========== GRADE 7 CLASSES ==========
  generateClass(28, '7', 'A', 'Mathematics', 'Prof. Nabil Harb', 33),
  generateClass(29, '7', 'B', 'Mathematics', 'Ms. Joelle Frem', 34),
  generateClass(30, '7', 'C', 'Mathematics', 'Mr. Rami Kanaan', 35),

  // ========== GRADE 8 CLASSES ==========
  generateClass(31, '8', 'A', 'Science', 'Dr. Antoine Gemayel', 36),
  generateClass(32, '8', 'B', 'Science', 'Ms. Maya Helou', 37),
  generateClass(33, '8', 'C', 'Science', 'Mr. Joseph Matar', 38),

  // ========== GRADE 9 CLASSES ==========
  generateClass(34, '9', 'A', 'English', 'Ms. Patricia Nassar', 39),
  generateClass(35, '9', 'B', 'English', 'Mr. David Khoury', 40),
  generateClass(36, '9', 'C', 'English', 'Ms. Nicole Haddad', 41),

  // ========== GRADE 10 CLASSES ==========
  // Section A - Multiple Subjects
  generateClass(37, '10', 'A', 'Mathematics', 'Prof. John Saad', 2),
  generateClass(38, '10', 'A', 'Physics', 'Dr. Maria Khalil', 1),
  generateClass(39, '10', 'A', 'Chemistry', 'Dr. Layla Nader', 3),
  generateClass(40, '10', 'A', 'Biology', 'Dr. Fadi Haddad', 5),
  generateClass(41, '10', 'A', 'English', 'Ms. Rania Barakat', 4),
  generateClass(42, '10', 'A', 'French', 'Ms. Sophie Dubois', 6),
  generateClass(401, '10', 'A', 'History', 'Mr. Hassan Omar', 42),
  generateClass(402, '10', 'A', 'Geography', 'Ms. Lina Karam', 43),
  generateClass(403, '10', 'A', 'Computer Science', 'Mr. Tarek Nabil', 44),
  generateClass(404, '10', 'A', 'Arabic', 'Ms. Fatima Said', 45),

  // Section B - Multiple Subjects
  generateClass(43, '10', 'B', 'Mathematics', 'Ms. Nadia Karam', 7),
  generateClass(44, '10', 'B', 'Physics', 'Dr. Antoine Gemayel', 36),
  generateClass(45, '10', 'B', 'Chemistry', 'Dr. Sami Haddad', 27),
  generateClass(46, '10', 'B', 'Biology', 'Ms. Maya Helou', 37),
  generateClass(47, '10', 'B', 'English', 'Mr. David Khoury', 40),
  generateClass(48, '10', 'B', 'French', 'Ms. Marie Laurent', 8),
  generateClass(405, '10', 'B', 'History', 'Mr. Hassan Omar', 42),
  generateClass(406, '10', 'B', 'Geography', 'Ms. Lina Karam', 43),
  generateClass(407, '10', 'B', 'Computer Science', 'Mr. Tarek Nabil', 44),
  generateClass(408, '10', 'B', 'Arabic', 'Ms. Fatima Said', 45),

  // ========== GRADE 11 CLASSES ==========
  // Section A - Multiple Subjects
  generateClass(49, '11', 'A', 'Mathematics', 'Prof. John Saad', 2),
  generateClass(50, '11', 'A', 'Physics', 'Dr. Maria Khalil', 1),
  generateClass(51, '11', 'A', 'Chemistry', 'Dr. Layla Nader', 3),
  generateClass(52, '11', 'A', 'Biology', 'Dr. Fadi Haddad', 5),
  generateClass(53, '11', 'A', 'English', 'Ms. Rania Barakat', 4),
  generateClass(54, '11', 'A', 'French', 'Ms. Sophie Dubois', 6),
  generateClass(409, '11', 'A', 'History', 'Mr. Hassan Omar', 42),
  generateClass(410, '11', 'A', 'Geography', 'Ms. Lina Karam', 43),
  generateClass(411, '11', 'A', 'Computer Science', 'Mr. Tarek Nabil', 44),
  generateClass(412, '11', 'A', 'Arabic', 'Ms. Fatima Said', 45),

  // Section B - Multiple Subjects
  generateClass(55, '11', 'B', 'Mathematics', 'Ms. Nadia Karam', 7),
  generateClass(56, '11', 'B', 'Physics', 'Dr. Antoine Gemayel', 36),
  generateClass(57, '11', 'B', 'Chemistry', 'Dr. Sami Haddad', 27),
  generateClass(58, '11', 'B', 'Biology', 'Ms. Maya Helou', 37),
  generateClass(59, '11', 'B', 'English', 'Mr. David Khoury', 40),
  generateClass(60, '11', 'B', 'French', 'Ms. Marie Laurent', 8),
  generateClass(413, '11', 'B', 'History', 'Mr. Hassan Omar', 42),
  generateClass(414, '11', 'B', 'Geography', 'Ms. Lina Karam', 43),
  generateClass(415, '11', 'B', 'Computer Science', 'Mr. Tarek Nabil', 44),
  generateClass(416, '11', 'B', 'Arabic', 'Ms. Fatima Said', 45),

  // Section C - Multiple Subjects
  generateClass(61, '11', 'C', 'Mathematics', 'Mr. Rami Kanaan', 35),
  generateClass(62, '11', 'C', 'Physics', 'Dr. Joseph Matar', 38),
  generateClass(63, '11', 'C', 'Chemistry', 'Mr. Karim Dagher', 29),
  generateClass(64, '11', 'C', 'Biology', 'Ms. Lara Frem', 28),
  generateClass(65, '11', 'C', 'English', 'Ms. Nicole Haddad', 41),
  generateClass(66, '11', 'C', 'French', 'Mr. Pierre Blanc', 9),
  generateClass(417, '11', 'C', 'History', 'Mr. Hassan Omar', 42),
  generateClass(418, '11', 'C', 'Geography', 'Ms. Lina Karam', 43),
  generateClass(419, '11', 'C', 'Computer Science', 'Mr. Tarek Nabil', 44),
  generateClass(420, '11', 'C', 'Arabic', 'Ms. Fatima Said', 45),

  // ========== GRADE 12 CLASSES ==========
  // Section A - Multiple Subjects
  generateClass(67, '12', 'A', 'Mathematics', 'Prof. John Saad', 2),
  generateClass(68, '12', 'A', 'Physics', 'Dr. Maria Khalil', 1),
  generateClass(69, '12', 'A', 'Chemistry', 'Dr. Layla Nader', 3),
  generateClass(70, '12', 'A', 'Biology', 'Dr. Fadi Haddad', 5),
  generateClass(71, '12', 'A', 'English', 'Ms. Rania Barakat', 4),
  generateClass(72, '12', 'A', 'French', 'Ms. Sophie Dubois', 6),
  generateClass(421, '12', 'A', 'History', 'Mr. Hassan Omar', 42),
  generateClass(422, '12', 'A', 'Geography', 'Ms. Lina Karam', 43),
  generateClass(423, '12', 'A', 'Computer Science', 'Mr. Tarek Nabil', 44),
  generateClass(424, '12', 'A', 'Arabic', 'Ms. Fatima Said', 45),

  // Section B - Multiple Subjects
  generateClass(73, '12', 'B', 'Mathematics', 'Ms. Nadia Karam', 7),
  generateClass(74, '12', 'B', 'Physics', 'Dr. Antoine Gemayel', 36),
  generateClass(75, '12', 'B', 'Chemistry', 'Dr. Sami Haddad', 27),
  generateClass(76, '12', 'B', 'Biology', 'Ms. Maya Helou', 37),
  generateClass(77, '12', 'B', 'English', 'Mr. David Khoury', 40),
  generateClass(78, '12', 'B', 'French', 'Ms. Marie Laurent', 8),
  generateClass(425, '12', 'B', 'History', 'Mr. Hassan Omar', 42),
  generateClass(426, '12', 'B', 'Geography', 'Ms. Lina Karam', 43),
  generateClass(427, '12', 'B', 'Computer Science', 'Mr. Tarek Nabil', 44),
  generateClass(428, '12', 'B', 'Arabic', 'Ms. Fatima Said', 45),

  // Section C - Multiple Subjects
  generateClass(79, '12', 'C', 'Mathematics', 'Mr. Rami Kanaan', 35),
  generateClass(80, '12', 'C', 'Physics', 'Dr. Joseph Matar', 38),
  generateClass(81, '12', 'C', 'Chemistry', 'Mr. Karim Dagher', 29),
  generateClass(82, '12', 'C', 'Biology', 'Ms. Lara Frem', 28),
  generateClass(83, '12', 'C', 'English', 'Ms. Nicole Haddad', 41),
  generateClass(84, '12', 'C', 'French', 'Mr. Pierre Blanc', 9),
  generateClass(429, '12', 'C', 'History', 'Mr. Hassan Omar', 42),
  generateClass(430, '12', 'C', 'Geography', 'Ms. Lina Karam', 43),
  generateClass(431, '12', 'C', 'Computer Science', 'Mr. Tarek Nabil', 44),
  generateClass(432, '12', 'C', 'Arabic', 'Ms. Fatima Said', 45),
];

// Populate classes with student IDs based on grade and section
baseClasses.forEach(cls => {
  // Find students matching this class's grade and section
  const matchingStudents = STUDENTS.filter(student => {
    // Match grade and section
    if (cls.grade === 10 || cls.grade === 11 || cls.grade === 12) {
      return student.grade === cls.grade && student.section === cls.section;
    }
    // For grades 1-9 and KG, no students yet (empty arrays)
    return false;
  });

  // Distribute students differently across subjects to create variety
  // Not all students take all subjects (electives, different tracks, etc.)
  if (matchingStudents.length > 0) {
    const allIds = matchingStudents.map(s => s.id);

    // For different subjects, include different subsets of students
    // This creates realistic variation where some students excel in certain subjects
    switch(cls.subject) {
      case 'Mathematics':
        // Include students with higher math/science aptitude (about 80% of class)
        cls.students = allIds.filter((id, idx) => {
          const student = matchingStudents[idx];
          // Include students good at math, or struggling students who need it
          return student.examReadiness >= 55 || idx % 3 === 0;
        });
        break;
      case 'Physics':
        // Physics typically has fewer students (science track)
        cls.students = allIds.filter((id, idx) => {
          const student = matchingStudents[idx];
          return student.examReadiness >= 60 || student.strengths.some(s =>
            s.toLowerCase().includes('science') || s.toLowerCase().includes('physics')
          );
        });
        break;
      case 'Chemistry':
        // Similar to physics but slightly different students
        cls.students = allIds.filter((id, idx) => {
          const student = matchingStudents[idx];
          return student.examReadiness >= 58 || student.strengths.some(s =>
            s.toLowerCase().includes('chemistry') || s.toLowerCase().includes('lab')
          );
        });
        break;
      case 'Biology':
        // Biology often attracts pre-med students
        cls.students = allIds.filter((id, idx) => {
          const student = matchingStudents[idx];
          return student.examReadiness >= 50 || student.strengths.some(s =>
            s.toLowerCase().includes('biology') || s.toLowerCase().includes('medicine')
          );
        });
        break;
      case 'English':
        // Most students take English (core subject)
        cls.students = allIds.filter((id, idx) => {
          const student = matchingStudents[idx];
          return student.examReadiness >= 45 || student.strengths.some(s =>
            s.toLowerCase().includes('writing') || s.toLowerCase().includes('language')
          ) || idx % 2 === 0;
        });
        break;
      case 'French':
        // French is often optional or second language
        cls.students = allIds.filter((id, idx) => {
          const student = matchingStudents[idx];
          return student.examReadiness >= 62 || student.strengths.some(s =>
            s.toLowerCase().includes('language')
          );
        });
        break;
      case 'History':
        // Most students take History (core subject)
        cls.students = allIds.filter((id, idx) => {
          const student = matchingStudents[idx];
          return student.examReadiness >= 50 || idx % 2 === 0;
        });
        break;
      case 'Geography':
        // Most students take Geography
        cls.students = allIds.filter((id, idx) => {
          const student = matchingStudents[idx];
          return student.examReadiness >= 48 || idx % 2 === 1;
        });
        break;
      case 'Computer Science':
        // Computer Science is popular among tech-oriented students
        cls.students = allIds.filter((id, idx) => {
          const student = matchingStudents[idx];
          return student.examReadiness >= 55 || student.strengths.some(s =>
            s.toLowerCase().includes('technology') || s.toLowerCase().includes('computer')
          ) || idx % 3 === 0;
        });
        break;
      case 'Arabic':
        // Arabic is usually a core subject
        cls.students = allIds.filter((id, idx) => {
          const student = matchingStudents[idx];
          return student.examReadiness >= 45 || student.strengths.some(s =>
            s.toLowerCase().includes('language') || s.toLowerCase().includes('writing')
          ) || idx % 2 === 0;
        });
        break;
      default:
        // Default: assign all students
        cls.students = allIds;
    }
  } else {
    cls.students = [];
  }
});

export const CLASSES = baseClasses;
